/**
 * @file    useActiveEngineDescriptor.ts
 * @scope   ENTERPRISE
 * @summary Resolves the active subtype descriptor from the drawer's `enterpriseChartType`.
 * @consumes engine registry (`resolveDescriptorById`)
 * @produces useActiveEngineDescriptor, ActiveEngineDescriptor
 * @sideEffects None.
 * @notes   `undefined` for legacy charts. Single place where the drawer turns the identity
 *          discriminator into behaviour (layout, validation, initial state).
 */
import { useMemo } from 'react';
import {
  AnyEngineDescriptor,
  resolveDescriptorById,
} from 'components/DiyWidgetEngine/ChartTypes/engineChartTypeRegistry';

export type ActiveEngineDescriptor = AnyEngineDescriptor | undefined;

export const useActiveEngineDescriptor = (chartTypeId?: string): ActiveEngineDescriptor =>
  useMemo(() => resolveDescriptorById(chartTypeId), [chartTypeId]);

export default useActiveEngineDescriptor;
